//There are no watcher in this file. These generators for redux-saga are
//used in multiple sagas

import { fork, select } from "redux-saga/effects";
import { getDesiredImageWidth } from "../../util/browserGeometry";
import {
  getFilenamesInLayer,
  getCurrentLayer,
  getNaturalAspect,
  getFilename,
} from "../selectors";
import { requestImageWorker } from "./requestImage";

export function* loadCurrentImage({ payload = {} }) {
  const { width = "" } = payload;
  const filename = yield select(getFilename);
  yield fork(requestImageWorker, { payload: { filename, key: width } });
}

export function* loadImagesInLayer(options = {}) {
  const { layer = yield select(getCurrentLayer) } = options;
  const filenames = yield select((state) =>
    getFilenamesInLayer(state, { layer, currentFirst: true })
  );
  const naturalAspect = yield select(getNaturalAspect);
  const width = getDesiredImageWidth(naturalAspect) || ""; //default to "" to fetch full resolution image
  for (const filename of filenames) {
    yield fork(requestImageWorker, { payload: { filename, key: width } });
  }
}
